const SvgAnalytics2 = (props) => (
  <>
    <circle cx={79.86} cy={96.78} r={28.04} fill="none" stroke={props.p30} strokeMiterlimit={10} />
    <circle cx={79.86} cy={96.78} r={56.08} fill="none" stroke={props.p30} strokeMiterlimit={10} />
    <path
      d="M-.52 96.62c0-22.68 9.22-43.03 24.22-57.75M80.86 176.89c-22.4 0-42.68-9.08-57.35-23.76M79.4 16.12c44.42 0 80.5 35.71 81.1 79.98M79.58 15.62v53.05M79.58 124.51v53.74M-.99 96.18h52.7M107.55 96.18h53.44M60.48 77.13 22.7 39.34M23.34 153.67l37.01-37.12"
      fill="none"
      stroke={props.p30}
      strokeMiterlimit={10}
    />
    <circle cx={40.34} cy={57.12} r={4} fill={props.p20} />
    <circle cx={107.68} cy={96.13} r={4} fill={props.p20} />
    <circle cx={79.55} cy={176.37} r={4} fill={props.p20} />
  </>
);

export default SvgAnalytics2;
